import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { CustomMUIButton } from '../../commons/buttons/CustomMUIButton';
import { ButtonClassNames, GlobalRouteNames } from '../../../models/Common';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux';
import { appSlice } from '../../../store/reducers/AppSlice';

export const BrizTvCtvRequest = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { setSuccess } = appSlice.actions;
  const { isSuccess } = useAppSelector((state) => state.appReducer);

  const handleClick = () => {
    dispatch(setSuccess(false));
    history.push(GlobalRouteNames.HomePage);
  };

  if (!isSuccess) {
    history.push(GlobalRouteNames.HomePage);
  }

  return (
    <div className="success-container briz-tv-ctv-request">
      <h1>{t('success.applicationAccepted')}</h1>
      <p className="success-text">{t('success.supportManagerWillContactYou')}</p>
      <div>
        <CustomMUIButton
          label={t('buttons.toMain')}
          handleClick={handleClick}
          className={ButtonClassNames.PrimaryFulfilled}
          isBold
        />
      </div>
    </div>
  );
};
